module.exports = require('mn-utils/joinProvider')(' ');
